import React from "react";

import MainButton from "../main-button";
import Loader from "../loader";
import LeftInfoModal from "../left-info-modal";
import Portal from "../portal/portal";

import { ImportInsuredsButtonProps } from "./import-button-types";
import { FLOW_AREA } from "../../constants/flow";
import { useImportInsureds } from "../../hooks/import-insureds-hook/useImportInsureds";

export const fileAccept =
  ".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.ms-excel.sheet.macroEnabled.12";

const ImportButton = ({
  onAddInsureds,
  maxInsureds,
  coverages,
  validateInsureds,
  jsonDataType,
  countries = [],
  flow,
  takerDocNumber,
}: ImportInsuredsButtonProps) => {
  const { loading, modal, fileInputRef, handleSelectFile, resetModal } = useImportInsureds({
    onAddInsureds,
    maxInsureds,
    coverages,
    validateInsureds,
    jsonDataType,
    countries,
    takerDocNumber,
  });

  if (loading) {
    return (
      <Portal>
        <Loader isLoadingMsg="Se están revisando los datos introducidos" />
      </Portal>
    );
  }

  return (
    <>
      <div className="upload-button">
        <input
          ref={fileInputRef}
          type="file"
          accept={fileAccept}
          onChange={handleSelectFile}
          style={{ display: "none" }}
          id="file-upload"
        />
        <label htmlFor="file-upload">
          <MainButton
            onClick={() => true}
            text="Importar asegurados"
            type={flow === FLOW_AREA.CONTRATACION ? "full-light" : ""}
          />
        </label>
      </div>
      <Portal>
        <LeftInfoModal
          img={modal.img}
          className={modal.className}
          mainTitle={modal.mainTitle}
          mainText={modal.mainText}
          list={modal.list}
          buttonText={modal.buttonText}
          onClickAccept={modal.onClickAccept}
          close={resetModal}
          closeButtonText={modal.closeButtonText}
          active={modal.active}
          noMainButton={modal.noMainButton}
          noSecondaryButton={modal.noSecondaryButton}
          centerPrimaryButton={modal.centerPrimaryButton}
        />
      </Portal>
    </>
  );
};

export default ImportButton;
